import React from "react";

export default function LoadingOverlay({ visible = false, text = "Loading…" }) {
  if (!visible) return null;
  return (
    <div className="loading-overlay" role="alert" aria-busy="true" aria-live="polite">
      <div className="loading-overlay__content" aria-label="Loading">
        <div className="loading-overlay__spinner" />
        <div className="loading-overlay__text">{text}</div>
      </div>
    </div>
  );
}
